import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { Leva } from 'leva'

import { Experience } from '@experience'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Experience />
    <Leva hidden />
  </React.StrictMode>,
)
